import { render, staticRenderFns } from "./schoolVideo.vue?vue&type=template&id=6929899a&"
import script from "./schoolVideo.vue?vue&type=script&lang=js&"
export * from "./schoolVideo.vue?vue&type=script&lang=js&"
import style0 from "./schoolVideo.vue?vue&type=style&index=0&id=6929899a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports